(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[188],{

/***/ 17285:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.AmpStateContext = void 0;

var _react = _interopRequireDefault(__webpack_require__(67294));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AmpStateContext = _react["default"].createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ 49546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isInAmpMode = isInAmpMode;
exports.useAmp = useAmp;

var _react = _interopRequireDefault(__webpack_require__(67294));

var _ampContext = __webpack_require__(17285);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

function useAmp() {
  // Don't assign the context value to a variable to save bytes
  return isInAmpMode(_react["default"].useContext(_ampContext.AmpStateContext));
}

if (typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) {
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 16505:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty = __webpack_require__(930);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

var _sideEffect = _interopRequireDefault(__webpack_require__(70148));

var _ampContext = __webpack_require__(17285);

var _headManagerContext = __webpack_require__(60523);

var _amp = __webpack_require__(49546);

var _utils = __webpack_require__(67206);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react["default"].createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react["default"].createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react["default"].Fragment) {
    return list.concat(_react["default"].Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
 returns a function for filtering head child elements
 which shouldn't be duplicated, like <title/>
 Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;
    var hasKey = false;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      hasKey = true;
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if ((metatype !== 'name' || !hasKey) && categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
 *
 * @param headElements List of multiple <Head> instances
 */


function reduceComponents(headElements, props) {
  return headElements.reduce(function (list, headElement) {
    var headElementChildren = _react["default"].Children.toArray(headElement.props.children);

    return list.concat(headElementChildren);
  }, []).reduce(onlyReactElement, []).reverse().concat(defaultHead(props.inAmpMode)).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if ( true && !props.inAmpMode) {
      if (c.type === 'link' && c.props['href'] && // TODO(prateekbh@): Replace this with const from `constants` when the tree shaking works.
      ['https://fonts.googleapis.com/css', 'https://use.typekit.net/'].some(function (url) {
        return c.props['href'].startsWith(url);
      })) {
        var newProps = _objectSpread({}, c.props || {});

        newProps['data-href'] = newProps['href'];
        newProps['href'] = undefined; // Add this attribute to make it easy to identify optimized tags

        newProps['data-optimized-fonts'] = true;
        return /*#__PURE__*/_react["default"].cloneElement(c, newProps);
      }
    }

    if (false) { var srcMessage; }

    return /*#__PURE__*/_react["default"].cloneElement(c, {
      key: key
    });
  });
}
/**
 * This component injects elements to `<head>` of your page.
 * To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
 */


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react).useContext(_ampContext.AmpStateContext);
  var headManager = (0, _react).useContext(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react["default"].createElement(_sideEffect["default"], {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _amp).isInAmpMode(ampState)
  }, children);
}

var _default = Head;
exports["default"] = _default;

if (typeof exports["default"] === 'function' || typeof exports["default"] === 'object' && exports["default"] !== null) {
  Object.assign(exports["default"], exports);
  module.exports = exports["default"];
}

/***/ }),

/***/ 70148:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _toConsumableArray = __webpack_require__(7980);

var _classCallCheck = __webpack_require__(33227);

var _createClass = __webpack_require__(88361);

var _assertThisInitialized = __webpack_require__(92191);

var _inherits = __webpack_require__(85971);

var _possibleConstructorReturn = __webpack_require__(52715);

var _getPrototypeOf = __webpack_require__(91193);

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(67294));

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var isServer = false;

var _class = /*#__PURE__*/function (_react$Component) {
  _inherits(_class, _react$Component);

  var _super = _createSuper(_class);

  function _class(props) {
    var _this;

    _classCallCheck(this, _class);

    _this = _super.call(this, props);

    _this.emitChange = function () {
      if (_this._hasHeadManager) {
        _this.props.headManager.updateHead(_this.props.reduceComponentsToState(_toConsumableArray(_this.props.headManager.mountedInstances), _this.props));
      }
    };

    _this._hasHeadManager = _this.props.headManager && _this.props.headManager.mountedInstances;

    if (isServer && _this._hasHeadManager) {
      _this.props.headManager.mountedInstances.add(_assertThisInitialized(_this));

      _this.emitChange();
    }

    return _this;
  }

  _createClass(_class, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances.add(this);
      }

      this.emitChange();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.emitChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances["delete"](this);
      }

      this.emitChange();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return _class;
}(_react.Component);

exports["default"] = _class;

/***/ }),

/***/ 97071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ PDFIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/Icon/PDF/pdf.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgPdf = function SvgPdf(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 24"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 1777"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1540",
    d: "M5.963 5.234V.291L.278 5.976h4.943c.534 0 .742-.208.742-.742Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1541",
    d: "M8.819 11.945a8.259 8.259 0 0 0 .414-1.759c.207-1.008-.052-1.629-.594-1.55s-.672.7-.62 1.344a5.342 5.342 0 0 0 .594 1.784s.1.258.206.181Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1542",
    d: "M6.339 17.118a5.839 5.839 0 0 0-2.041 1.086c-.7.673-.648 1.267-.336 1.473s1.189-.414 1.732-1.06a5.145 5.145 0 0 0 .9-1.4c.004-.099-.047-.177-.255-.099Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1543",
    d: "M8.214 16.028c.515-.206 2.377-.621 2.377-.621s-1.214-1.447-1.37-1.732c0 .001-.724 1.888-1.007 2.353Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1544",
    d: "M17.051 0H6.97v5.864a1.171 1.171 0 0 1-1.164 1.174H0v16a.955.955 0 0 0 .949.957h16.1a.954.954 0 0 0 .949-.957V.956A.954.954 0 0 0 17.051 0Zm-3.106 17.849a7.087 7.087 0 0 1-2.917-1.886.23.23 0 0 0-.069-.015c-.15 0-1.82.485-3.088.848-1.854 3.341-3.7 4.294-4.567 3.189-.456-.582-.28-1.955 1.914-2.984a14.164 14.164 0 0 1 1.77-.668 31.5 31.5 0 0 0 1.573-3.579 10.185 10.185 0 0 1-1.072-2.772c-.1-1.081.357-2.059 1.276-2.059 1.171 0 2.04 1.132.668 5.111a12.589 12.589 0 0 0 1.673 2.246 13.561 13.561 0 0 1 2.784-.261c1.651.1 1.994.877 2.045 1.469a1.6 1.6 0 0 1-1.99 1.361Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "\\u30D1\\u30B9 1545",
    d: "M13.761 15.555a6.219 6.219 0 0 0-2.069.258 6.871 6.871 0 0 0 2.093 1.035c.777.1 1.062-.232 1.062-.568s-.284-.673-1.086-.725Z"
  }))));
};
/* harmony default export */ var pdf = (SvgPdf);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Icon/PDF/index.tsx


var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var PDFIcon = function PDFIcon(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'regular' : _ref$size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, _objectSpread(_objectSpread({}, props), {}, {
    "data-size": size
  }));
};
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(pdf).withConfig({
  displayName: "PDF__StyledIcon",
  componentId: "sc-18bayee-0"
})(["transition:fill 0.3s ease;fill:", ";&[data-size='regular']{width:18px;height:24px;}&[data-size='small']{width:12px;height:28px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);

/***/ }),

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 89085:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ PublicNoticePage; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./src/utils/date.ts
var utils_date = __webpack_require__(16645);
// EXTERNAL MODULE: ./src/components/elements/Icon/PDF/index.tsx + 1 modules
var PDF = __webpack_require__(97071);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/layouts/PublicNotice/PDFItem.tsx






var PDFItem = function PDFItem(_ref) {
  var date = _ref.date,
      fileName = _ref.fileName,
      filePath = _ref.filePath;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(StyledLink, {
    href: filePath,
    target: "_blank",
    rel: "noreferrer noopener",
    children: [date && /*#__PURE__*/(0,jsx_runtime.jsx)(Time, {
      dateTime: date,
      children: (0,utils_date/* formatDate */.p6)(date, 'yyyy/MM/dd')
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Icon, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(Name, {
      children: fileName
    })]
  });
};
var Time = styled_components_browser_esm/* default.time.withConfig */.ZP.time.withConfig({
  displayName: "PDFItem__Time",
  componentId: "sc-hhph99-0"
})(["font-weight:700;line-height:1.6;"]);
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "PDFItem__StyledLink",
  componentId: "sc-hhph99-1"
})(["transition:color 0.3s ease;display:flex;align-items:center;gap:10px;padding-top:18px;padding-bottom:20px;width:100%;&:hover{> span{color:", ";text-decoration:underline;}> svg{fill:", ";}}"], theme/* theme.colors.lightBlue */.r.colors.lightBlue, theme/* theme.colors.lightBlue */.r.colors.lightBlue);
var Name = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "PDFItem__Name",
  componentId: "sc-hhph99-2"
})(["line-height:1.6;"]);
var Icon = (0,styled_components_browser_esm/* default */.ZP)(PDF/* PDFIcon */.H).withConfig({
  displayName: "PDFItem__Icon",
  componentId: "sc-hhph99-3"
})(["flex-shrink:0;"]);
;// CONCATENATED MODULE: ./src/components/layouts/PublicNotice/PDFList.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var PDFList = function PDFList(_ref) {
  var pdfList = _ref.pdfList;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("ul", {
    children: pdfList.map(function (pdf) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(Item, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(PDFItem, _objectSpread({}, pdf))
      }, pdf.id);
    })
  });
};
var Item = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
  displayName: "PDFList__Item",
  componentId: "sc-zf4hbn-0"
})(["display:flex;align-items:center;border-bottom:1px solid ", ";"], theme/* theme.colors.backgroundBlue */.r.colors.backgroundBlue);
;// CONCATENATED MODULE: ./src/components/pages/PublicNotice/Pdffiles.tsx
// import { AHeading, BHeading } from '@Layouts/Ir/Heading'



 // import { Paragraph } from '@/components/layouts/Ir/Paragraph'





var PublicNoticePDF = function PublicNoticePDF(_ref) {
  var _bulletin$0$type$titl, _bulletin$0$type, _finalAccount$0$type$, _finalAccount$0$type;

  var company = _ref.company,
      bulletin = _ref.bulletin,
      finalAccount = _ref.finalAccount;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(AHeading, {
      children: company.companyName
    }), company.comments && /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
      children: company.comments
    }), company.showBulletin && /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubHeading, {
        children: "\u516C\u544A\u4E8B\u9805"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 20,
          pc: 36
        }
      }), bulletin.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ItemContainer, {
          children: bulletin.map(function (item, index) {
            var _item$company;

            return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(PDFList, {
                pdfList: [{
                  id: item.pdf._id,
                  fileName: item.title,
                  filePath: item.pdf.src
                }]
              })
            }, "".concat(index).concat((_item$company = item.company) === null || _item$company === void 0 ? void 0 : _item$company._id).concat(item.index).concat(item.title));
          })
        }, (_bulletin$0$type$titl = (_bulletin$0$type = bulletin[0].type) === null || _bulletin$0$type === void 0 ? void 0 : _bulletin$0$type.title) !== null && _bulletin$0$type$titl !== void 0 ? _bulletin$0$type$titl : 'bulletin')
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
        children: "\u73FE\u5728\u3001\u516C\u544A\u3059\u3079\u304D\u4E8B\u9805\u306F\u3054\u3056\u3044\u307E\u305B\u3093\u3002"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 50,
          pc: 80
        }
      })]
    }), company.showFinalAccounts && /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SubHeading, {
        children: "\u6C7A\u7B97\u516C\u544A"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 20,
          pc: 36
        }
      }), company.finalAccountSummary && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
          children: company.finalAccountSummary.split('→').map(function (value, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
              children: [value, /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
            }, "".concat(index).concat(value));
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            sp: 10,
            pc: 15
          }
        })]
      }), finalAccount.length > 0 ? /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(ItemContainer, {
          children: finalAccount.map(function (item, index) {
            var _item$company2;

            return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(PDFList, {
                pdfList: [{
                  id: item.pdf._id,
                  fileName: item.title,
                  filePath: item.pdf.src
                }]
              })
            }, "".concat(index).concat((_item$company2 = item.company) === null || _item$company2 === void 0 ? void 0 : _item$company2._id).concat(item.index).concat(item.title));
          })
        }, (_finalAccount$0$type$ = (_finalAccount$0$type = finalAccount[0].type) === null || _finalAccount$0$type === void 0 ? void 0 : _finalAccount$0$type.title) !== null && _finalAccount$0$type$ !== void 0 ? _finalAccount$0$type$ : 'finalAccount')
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
        children: "\u73FE\u5728\u3001\u6C7A\u7B97\u516C\u544A\u4E8B\u9805\u306F\u3054\u3056\u3044\u307E\u305B\u3093\u3002"
      }), company.finalAccountComments && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            sp: 10,
            pc: 15
          }
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph, {
          children: company.finalAccountComments.split('→').map(function (value, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
              children: [value, /*#__PURE__*/(0,jsx_runtime.jsx)("br", {})]
            }, "".concat(index).concat(value));
          })
        })]
      })]
    })]
  });
};
var SubHeading = styled_components_browser_esm/* default.h3.withConfig */.ZP.h3.withConfig({
  displayName: "Pdffiles__SubHeading",
  componentId: "sc-1v771iz-0"
})(["font-size:24px;font-weight:700;line-height:140%;color:", ";@media screen and (max-width:1047px){font-size:20px;line-height:130%;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var ItemContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Pdffiles__ItemContainer",
  componentId: "sc-1v771iz-1"
})(["display:flex;flex-direction:column;font-size:16px;line-height:25.6px;color:", ";@media screen and (max-width:1047px){font-size:15px;line-height:24px;}"], theme/* theme.colors.textTitle */.r.colors.textTitle);
var Paragraph = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "Pdffiles__Paragraph",
  componentId: "sc-1v771iz-2"
})(["font-size:16px;line-height:190%;@media screen and (max-width:1047px){font-size:15px;line-height:180%;}"]);
var AHeading = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
  displayName: "Pdffiles__AHeading",
  componentId: "sc-1v771iz-3"
})(["font-size:28px;font-weight:700;line-height:1.2;color:", ";border-bottom:1px solid ", ";padding-bottom:22px;margin-bottom:50px;@media screen and (max-width:1047px){font-size:19px;padding-bottom:10px;margin-bottom:30px;}"], theme/* theme.colors.textTitle */.r.colors.textTitle, theme/* theme.colors.grey */.r.colors.grey);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
;// CONCATENATED MODULE: ./src/components/layouts/PublicNotice/BulletedList.tsx


var BulletedList = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
  displayName: "BulletedList",
  componentId: "sc-rqbf6q-0"
})(["font-size:16px;line-height:1.3;list-style:", ";margin-left:24px;display:flex;flex-direction:column;gap:21px;> li::marker{color:", ";}@media screen and (max-width:1047px){font-size:15px;line-height:1.6;gap:12px;}"], function (_ref) {
  var listStyle = _ref.listStyle;
  return listStyle !== null && listStyle !== void 0 ? listStyle : 'disc';
}, function (_ref2) {
  var listStyle = _ref2.listStyle;
  return listStyle === 'decimal' ? theme/* theme.colors.textTitle */.r.colors.textTitle : theme/* theme.colors.grey */.r.colors.grey;
});
;// CONCATENATED MODULE: ./src/components/pages/PublicNotice/index.tsx






 // import { Layout } from '@/components/layouts/Ir'

 // import { Paragraph } from '@/components/layouts/Ir/Paragraph'




var PublicNoticePage = function PublicNoticePage(_ref) {
  var bulletinDigest = _ref.bulletinDigest,
      companyList = _ref.companyList,
      bulletinList = _ref.bulletinList,
      finalAccountList = _ref.finalAccountList;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Container, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      titleText: "Electronic Public Notice",
      subTitleText: "\u96FB\u5B50\u516C\u544A",
      color: "normal"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), bulletinDigest.title && /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PublicNotice_Paragraph, {
        children: bulletinDigest.summary
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 10,
          pc: 15
        }
      }), bulletinDigest.listItems.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(BulletedList, {
        children: bulletinDigest.listItems.slice(1).split('→').map(function (value, index) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
            children: value
          }, "".concat(index).concat(value));
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 70,
          pc: 100
        }
      })]
    }), companyList.map(function (company) {
      return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(PublicNoticePDF, {
          company: company,
          bulletin: bulletinList[company._id],
          finalAccount: finalAccountList[company._id]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
          h: {
            sp: 70,
            pc: 100
          }
        })]
      }, "".concat(company._id));
    })]
  });
};

PublicNoticePage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '電子公告',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "\u96FB\u5B50\u516C\u544A",
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u30B0\u30EB\u30FC\u30D7\u306E\u516C\u544A\u306B\u3064\u3044\u3066\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        url: '/public-notice'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, {
      title: "Electronic Public Notice",
      subTitle: "\u96FB\u5B50\u516C\u544A",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};

var PublicNotice_Paragraph = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
  displayName: "PublicNotice__Paragraph",
  componentId: "sc-qx2242-0"
})(["font-size:16px;line-height:190%;@media screen and (max-width:1047px){font-size:15px;line-height:180%;}"]);
var Container = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "PublicNotice__Container",
  componentId: "sc-qx2242-1"
})(["width:1040px;margin:94px auto 130px;@media screen and (max-width:1047px){margin:38px auto 120px;width:100%;padding:0 20px;}"]);
;// CONCATENATED MODULE: ./src/pages/public-notice/index.tsx
var __N_SSG = true;


/***/ }),

/***/ 16645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "bp": function() { return /* binding */ isEqualYear; },
/* harmony export */   "dG": function() { return /* binding */ isEqualMonth; },
/* harmony export */   "p6": function() { return /* binding */ formatDate; }
/* harmony export */ });
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72167);

var formatDate = function formatDate(date, formatType) {
  try {
    return (0,date_fns__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Date(date), formatType);
  } catch (e) {
    return date;
  }
};
var isEqualYear = function isEqualYear(date, year) {
  return formatDate(date, 'yyyy') === year;
};
var isEqualMonth = function isEqualMonth(date, month) {
  return formatDate(date, 'M') === month;
};

/***/ }),

/***/ 91377:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/public-notice",
      function () {
        return __webpack_require__(89085);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(16505)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,2167,5548,9774,2888,179], function() { return __webpack_exec__(91377); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);